/* Make4PRO, 15-08: offerteaanvraag vanaf een productpagina.

   Producten met de tag "op aanvraag" krijgen geen koopknop maar een
   offerteknop naar /pages/contact?product=<titel>. Dit script zet die
   productnaam in het berichtveld van het contactformulier, zodat de
   bezoeker niet zelf moet typen over welke machine het gaat.

   Het verzint niets: de tekst komt uit de producttitel in de URL. */
(function () {
  function vul() {
    var p = new URLSearchParams(window.location.search).get('product');
    if (!p) return;
    var veld = document.querySelector('textarea[name="contact[body]"]');
    if (!veld) return;
    if (veld.value.trim() === '') {
      veld.value = 'Ik vraag een offerte voor: ' + p + '\n\n';
    }
    if (!document.querySelector('.m4p-offerte-melding')) {
      var melding = document.createElement('p');
      melding.className = 'm4p-offerte-melding';
      melding.textContent = 'Je vraagt een offerte aan voor ' + p + '.';
      veld.parentNode.insertBefore(melding, veld);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vul);
  } else {
    vul();
  }
})();
